
$(document).on('click', '.hk-element-sub-option:not(.hk-active)', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($('.hk-element-option.hk-active').attr('selling_plan'), 10); // 1,2,3...
  if (!tab) return;
  // Remove active from siblings
  $('.hk-element-sub-option').removeClass('hk-active');
  // Add active to current
  $this.addClass('hk-active');
$('.hk-sub-trigger').hide();
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show();
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});
$(document).on('click', '.hk-element-sub-option.hk-active', function () {
$('.hk-element-sub-option:not(.hk-active)').trigger('click');
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('data_tab'), 10); // 1,2,3...
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...
  var selling_plan = parseInt($(this).attr('selling_plan'), 10); // 1,2,3...
  var sub_tab = parseInt($('.hk-element-sub-option.hk-active').attr('sub_tab'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide(); 
$('.hk-quantity-trigger[data_tab="'+tab+'"]').show();
$('.hk-checkout-button').attr('quantity',quantity);
var selected_title = $this.find('.hk-option-title').text();
$('.hk-pdp-pdt-sub-heading1 strong').text(selected_title);
if (sub_tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').addClass('hk-active');
});


$(document).on("click", ".hk-pdp-popup-top .hk-icon-with-text-flex .hk-element-image", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').removeClass('hk-active');
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.shopify-section:has(.hk-hide-desktop .hk-pdp-pdt-header)').scrollIntoView({
    behavior: 'smooth'
  })
});